import styled from 'styled-components';

export const NavbarContainer = styled.nav<{ $transparent?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: ${(props) =>
    props.$transparent
      ? props.theme.COLORS.pNavbarTransparentBg
      : props.theme.COLORS.pNavbarBg};
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 23px;
  z-index: 1000;
  box-shadow: ${(props) => (props.$transparent ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.1)')};
`;

export const NavbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 85px;
`;

export const Logo = styled.div<{ $logoSrc: string }>`
  width: 152px;
  height: 22px;
  background-image: url('${(props) => props.$logoSrc}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 38px;
`;

export const MenuItem = styled.a<{ $active?: boolean }>`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: ${(props) =>
    props.$active
      ? props.theme.COLORS.pMenuActiveColor
      : props.theme.COLORS.pMenuTextColor};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${(props) => props.theme.COLORS.pMenuActiveColor};
  }
`;

export const NavbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const AuthSection = styled.div`
  display: flex;
  align-items: center;
  gap: 26px;
`;

export const LoginLink = styled.a`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: ${(props) => props.theme.COLORS.pMenuTextColor};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${(props) => props.theme.COLORS.pMenuActiveColor};
  }
`;

export const SignUpButton = styled.button`
  width: 110px;
  height: 36px;
  background: ${(props) => props.theme.COLORS.pDepositButtonBg};
  border: none;
  border-radius: 30px;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => props.theme.COLORS.pDepositButtonText};
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const IconButton = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
  position: relative;

  &:hover {
    opacity: 1;
  }
`;

export const LanguageDropdown = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 150px;
  background: ${(props) => props.theme.COLORS.DropdownBg};
  border: 1px solid ${(props) => props.theme.COLORS.pHeaderDividerColor};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: ${(props) => (props.$isOpen ? 'flex' : 'none')};
  flex-direction: column;
  overflow: hidden;
`;

export const LanguageOption = styled.button<{ $active: boolean }>`
  width: 100%;
  padding: 12px 16px;
  background: ${(props) =>
    props.$active ? 'rgba(111, 201, 217, 0.2)' : 'transparent'};
  border: none;
  text-align: left;
  font-family: 'Rubik', sans-serif;
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  font-size: 14px;
  color: ${(props) => props.theme.COLORS.pMenuTextColor};
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: rgba(111, 201, 217, 0.15);
  }
`;

export const CheckIcon = styled.span`
  color: ${(props) => props.theme.COLORS.pMenuActiveColor};
  font-weight: 600;
`;

// Logged-in state styled components
export const SearchInputBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 238px;
  height: 36px;
  padding: 12px 11px 12px 12px;
  background: ${(props) => props.theme.COLORS.pSearchInputBg};
  border-radius: 30px;

  svg {
    color: ${(props) => props.theme.COLORS.pSearchInputPlaceholder};
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: ${(props) => props.theme.COLORS.pMenuTextColor};

  &::placeholder {
    color: ${(props) => props.theme.COLORS.pSearchInputPlaceholder};
  }
`;

export const DepositButton = styled.button`
  width: 102px;
  height: 36px;
  padding: 7px 17px;
  background: ${(props) => props.theme.COLORS.pDepositButtonBg};
  border: none;
  border-radius: 30px;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => props.theme.COLORS.pDepositButtonText};
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const AssetsLink = styled.a`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: ${(props) => props.theme.COLORS.pMenuTextColor};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${(props) => props.theme.COLORS.pMenuActiveColor};
  }
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 20px;
  background: ${(props) => props.theme.COLORS.pHeaderDividerColor};
`;

export const IconButtonWithBadge = styled.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
  position: relative;

  &:hover {
    opacity: 1;
  }
`;

export const NotificationBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background: ${(props) => props.theme.COLORS.pNotificationBadge};
  border-radius: 50%;
`;

export const LoggedInSection = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;
`;

export const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;
`;
